import { Controller } from "@hotwired/stimulus";

// Navigates to facility detail when the row is clicked (supply chain index table).
export default class extends Controller {
  static values = { url: String };

  visit(event) {
    if (event.target.closest("a, button, input, label, select, textarea")) return;
    window.location.assign(this.urlValue);
  }

  keydown(event) {
    if (event.key !== "Enter" && event.key !== " ") return;
    event.preventDefault();
    window.location.assign(this.urlValue);
  }
}
